import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/system';
import MuiTypography from '@mui/material/Typography';
import Button from '../../../Button/Button.js';
import Checkbox from '../../../Checkbox/Checkbox.js';
import '../../../Checkbox/CheckboxList.js';
import Property from '../../../properties/Property.js';
import '../../../Input/Input.js';
import '../../../ClockInput/ClockInput.js';
import 'react';
import '../../../BaseDropdown/BaseDropdown.js';
import '../../../BaseDropdown/types.js';
import '../../../BaseDropdown/components/VirtualizedMenuList.js';
import '../../../Dropdown/components/OptionItem.js';
import '../../../Dropdown/components/Menu.js';
import '../../../Dropdown/context/DropdownProvider.js';
import 'react-select';
import '@mui/material/styles';
import 'lodash';
import '../../../MultiSelectDropdown/components/SearchBar.js';
import '../../../MultiSelectDropdown/context/MultiSelectProvider.js';
import '../../../MultiSelectDropdown/components/OptionItem.js';
import '../../../MultiSelectDropdown/components/ValueContainer.js';
import '../../../MultiSelectDropdown/components/Group.js';
import '../../../MultiSelectDropdown/components/GroupHeading.js';
import '../../../TimeInput/TimeInput.js';
import '../../../PillStatus/PillStatus.js';
import '../../../properties/MultilineInputProperty.js';
import '../../../properties/IconProperty.js';
import '../../../DatePicker/DatePicker.js';
import 'date-fns/endOfWeek';
import 'date-fns/isSameDay';
import 'date-fns/startOfWeek';
import 'date-fns/isWithinInterval';
import 'date-fns/isValid';
import '../../../RangeDatePicker/components/RangeDateFooter.js';
import '../../../RangeDatePicker/components/RangeDateHeader.js';
import 'date-fns/isSameWeek';
import 'date-fns/isLastDayOfMonth';
import 'date-fns/isFirstDayOfMonth';
import 'date-fns';
import 'date-fns/format';
import 'date-fns/getDay';
import '../../../BaseDatePicker/components/DayContent.js';
import '../../../BaseDatePicker/components/BaseDatePickerPopper/BaseDatePickerPopper.js';
import '../../../BaseDatePicker/components/DatePickerInput/DatePickerInput.js';
import '../../../BaseDatePicker/BaseDatePicker.js';

const PropertyContainer = styled('div') `
  ${({ theme }) => `
    display: flex;
    align-items: center;
    margin-right: ${theme.spacing(7.5)};
    color: ${theme.palette.N30.main};
    
    span {
      margin-right: ${theme.spacing(2)};
    }
  `}
`;
const _UpdateButton = styled(Button) `
  ${({ theme }) => `
    width: ${theme.spacing(16.5)};
    height: ${theme.spacing(5)};
    `};
`;
const CustomCheckboxProperty = (_a) => {
    var { value, label, onClick, loading } = _a, rest = __rest(_a, ["value", "label", "onClick", "loading"]);
    return (jsxs(Property, Object.assign({ label: label }, rest, { children: [jsxs(PropertyContainer, { children: [jsx(Checkbox, {}), value] }), jsx(_UpdateButton, Object.assign({ variant: "ghost", loading: loading, onClick: onClick, size: "small" }, { children: jsx(MuiTypography, Object.assign({ fontWeight: "bold", fontSize: "10px", lineHeight: "16px", className: "update", width: "42px", height: "14px", letterSpacing: "0.4px" }, { children: "UPDATE" })) }))] })));
};

export { CustomCheckboxProperty as default };
//# sourceMappingURL=CustomCheckboxProperty.js.map
